'use client';
import CircularLoading from '@/components/CircularLoader/CircularLoader';
import Loader from '@/components/Styled/Loader';
import { cn } from '@/lib/utils';
import { useBreakpointHooks } from '@/utils/break-points.provider';
import NekiLogo from '@components/NekiLogo';
import { Dialog as HeadlessDialog, Transition } from '@headlessui/react';
import Button from '@ui/Button';
import Typography from '@ui/Typography';
import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import { cva, cx } from 'cva';
import Image from 'next/image';
import React, { Fragment } from 'react';
import { MdClose } from 'react-icons/md';

const dialog = cva('dialog', {
  variants: {
    maxWidth: {
      sm: ['w-full lg:max-w-sm'],
      md: ['w-full lg:max-w-md'],
      lg: ['w-full lg:max-w-screen-lg'],
      auto: [''],
    },
  },
});

function DialogTitle(props) {
  const { iconUrl, title } = props;

  const isLessThanSmallScreen = useBreakpointHooks((bp) => bp.useSmaller('sm'));

  const getTitle = (titleName) => {
    if (isLessThanSmallScreen) {
      return titleName.length > 28 ? `${titleName.slice(0, 28)}...` : titleName;
    }
    return titleName;
  };

  if (
    iconUrl &&
    iconUrl.trim().length > 0 &&
    title &&
    title.trim().length > 0
  ) {
    return (
      <div className="relative flex w-full flex-col gap-2 md:flex-row md:items-center md:gap-8 lg:gap-24">
        <div className="flex flex-col items-start justify-start gap-0.5">
          <Image
            src={getQualifiedImageUrl(iconUrl) || ''}
            width={64}
            height={64}
            alt="community-logo"
            className="object-contain object-center"
          />
          <div className="flex flex-row items-center justify-start gap-1">
            <Typography variant="h6" color="textSecondary">
              Powered by
            </Typography>
            <NekiLogo className="!h-4" />
          </div>
        </div>
        {/* <Typography
          variant="dialogtitle"
          color="textSecondary flex items-center justify-center"
          className="line-clamp-1 w-[90%] overflow-hidden truncate text-ellipsis">
          {title.length > 28 ? `${title.slice(0, 28)}...` : title}
        </Typography> */}
        <div className="flex flex-1 items-center overflow-hidden truncate">
          <div className={cx('')}>
            <Typography variant="dialogtitle" color="textSecondary">
              {/* {title.length > 28 ? `${title.slice(0, 28)}...` : title} */}
              {getTitle(title)}
            </Typography>
          </div>
        </div>
      </div>
    );
  }
  if (iconUrl && iconUrl.trim().length > 0) {
    return (
      <div className="flex flex-col items-start justify-start gap-0.5">
        <Image
          src={getQualifiedImageUrl(iconUrl) || ''}
          width={64}
          height={64}
          alt="community-logo"
          className="object-contain object-center"
        />
        <div className="flex items-center justify-start gap-1">
          <Typography variant="h6" color="textSecondary">
            Powered by
          </Typography>
          <NekiLogo className="!h-4" />
        </div>
      </div>
    );
  } else if (title && title.trim().length > 0) {
    // return (
    //   <div className=" flex">
    //     <div className=" flex flex-col items-start justify-start gap-0.5">
    //       <Image
    //         src={
    //           getQualifiedImageUrl(
    //             'https://s3.amazonaws.com/my.neki.io.prod/assets/images/Neki-Logo.svg',
    //           ) || ''
    //         }
    //         width={128}
    //         height={128}
    //         alt="community-logo"
    //         className={cx(
    //           'object-contain object-center',
    //           isLessThanSmallScreen && 'hidden',
    //         )}
    //       />
    //     </div>
    //     <Typography
    //       variant="dialogtitle"
    //       color="textSecondary"
    //       className="w-full text-center">
    //       {title.length > 28 ? `${title.slice(0, 28)}...` : title}
    //       {/* {title} */}
    //     </Typography>
    //   </div>
    // );
    return (
      <Typography
        variant="dialogtitle"
        color="textSecondary"
        className="w-full">
        {/* {title.length > 28 ? `${title.slice(0, 28)}...` : title} */}
        {getTitle(title)}
      </Typography>
    );
    // return (
    //   <div className="relative flex w-full flex-col gap-2 md:flex-row md:items-center md:gap-8 lg:gap-24">
    //     <div className="flex flex-col items-start justify-start gap-0.5">
    //       <Image
    //         src={
    //           getQualifiedImageUrl(
    //             'https://s3.amazonaws.com/my.neki.io.prod/assets/images/Neki-Logo.svg',
    //           ) || ''
    //         }
    //         width={128}
    //         height={128}
    //         alt="community-logo"
    //         className="object-contain object-center"
    //       />
    //     </div>
    //     <div className="flex flex-1 items-center overflow-hidden truncate">
    //       <div
    //         className={cx(
    //           'transform truncate transition-transform lg:absolute lg:left-0 lg:translate-x-[calc(303px+4rem)]',
    //         )}>
    //         <Typography variant="dialogtitle" color="textSecondary">
    //           {title.length > 28 ? `${title.slice(0, 28)}...` : title}
    //         </Typography>
    //       </div>
    //     </div>
    //     {/* <div className="flex flex-1 items-center overflow-hidden truncate">
    //       <div className={cx('')}>
    //         <Typography variant="dialogtitle" color="textSecondary">
    //           {title.length > 28 ? `${title.slice(0, 28)}...` : title}
    //         </Typography>
    //       </div>
    //     </div> */}
    //   </div>
    // );
  }
  return <NekiLogo className="!h-12" />;
}

function Dialog(props) {
  const {
    isOpen,
    onClose,
    className,
    children,
    contentClass,
    titleClass,
    maxWidth = 'auto',
    iconUrl = null,
    title,
    loading = false,
    noClose = false,
    preventOutsideClose = false,
  } = props;

  const dialogClasses = dialog({
    maxWidth: maxWidth,
    className: cn(
      'flex flex-col h-screen p-0 transform overflow-hidden bg-white text-left align-middle shadow-xl transition-all lg:h-auto lg:max-h-[calc(100vh-8rem)] lg:rounded-2xl',
      className,
    ),
  });

  const handleClose = (event) => {
    if (preventOutsideClose && event.target === event.currentTarget) {
      return; // Prevent closing if clicking on the overlay
    }
    onClose();
  };

  // if (loading) {
  //   return <CircularLoading loaderState />;
  // }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <HeadlessDialog
        as="div"
        className="relative z-1000"
        open={isOpen}
        onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-40" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="flex items-center justify-center text-center lg:mt-12 lg:items-start lg:p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <HeadlessDialog.Panel className={dialogClasses}>
                <div
                  className={cn(
                    // 'flex items-center justify-start px-6 pt-6 lg:px-8 lg:pt-8',
                    'flex items-center justify-start px-6 pt-6 lg:px-8',
                    titleClass,
                  )}>
                  <div className="h-full w-full flex-1">
                    <DialogTitle iconUrl={iconUrl} title={title} />
                  </div>

                  {!noClose && (
                    <Button variant="icon" onClick={handleClose}>
                      <MdClose className="h-8 w-8" />
                    </Button>
                  )}
                </div>
                <div
                  className={cn(
                    'flex h-full flex-1 overflow-y-auto overflow-x-hidden p-6 lg:p-8',
                    `${
                      loading ? 'min-h-[400px] items-center justify-center' : ''
                    }`,
                    contentClass,
                  )}>
                  {loading ? <Loader /> : children}
                </div>
              </HeadlessDialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </HeadlessDialog>
    </Transition>
  );
}

export default Dialog;
